import React from "react";
import { DropdownButton } from "react-bootstrap";
import Chip from "./Chip";
import { useWindowSize } from "../../context/WindowSizeContext";

type Props = {
  items: {
    id: string | number;
    name: string;
    link?: string;
  }[];
  onRemove?: $TSFixMeFunction;
  withTooltip?: boolean;
};

export default function Chips({ items, onRemove, withTooltip = false }: Props) {
  const chipsRef = React.useRef(null);
  const [displayedChips, setDisplayedChips] = React.useState();
  const [isOpen, setIsOpen] = React.useState(false);
  const windowSize = useWindowSize();

  React.useEffect(() => {
    /* istanbul ignore next */
    const calculateDisplayedChips = () => {
      if (chipsRef.current) {
        const chipsContainer = chipsRef.current;
        const chipsElements = Array.from((chipsContainer as $TSFixMe).children);
        // - 50px for the +(number of chips in dropdown) action and for when hidden items are in the thousands
        const availableWidth =
          Math.floor((chipsContainer as $TSFixMe).clientWidth) - 50;
        let remainingWidth = availableWidth;
        const visibleChips: $TSFixMe = [];
        items.forEach((chip) => {
          const chipElement = chipsElements.find(
            (element) => (element as $TSFixMe).textContent === chip.name,
          );
          if (chipElement) {
            // + 4px because gap between the chips
            const chipWidth =
              Math.floor((chipElement as $TSFixMe).clientWidth) + 4;
            if (remainingWidth - chipWidth <= 0) return;
            remainingWidth -= chipWidth;
            visibleChips.push(chip);
          }
        });
        setDisplayedChips(visibleChips);
      }
    };
    calculateDisplayedChips();
  }, [items, (windowSize as $TSFixMe).width]);

  // istanbul ignore next
  const onDropdownClose = (e: $TSFixMe) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
  };

  const chipsInDropdown = items?.filter(
    (chip) =>
      !(displayedChips as $TSFixMe)?.some(
        (displayedChip: $TSFixMe) =>
          displayedChip.name === chip.name && displayedChip.link === chip.link,
      ),
  );
  const dropdown = (displayedChips as $TSFixMe)?.length < items.length && (
    <div className="chips-item-actions">
      <div className="list-item-menu">
        <DropdownButton
          bsStyle="default"
          title={
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            <span className="chip more-chips">{`+${items.length - displayedChips.length}`}</span>
          }
          noCaret
          id="dropdown-menu"
          pullRight
          open={isOpen}
          onClick={
            /* istanbul ignore next */ (e) => {
              e.preventDefault();
              e.stopPropagation();
            }
          }
          onToggle={() => setIsOpen(!isOpen)}
        >
          {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
          {chipsInDropdown.map((chip) => (
            <li
              onClick={
                /* istanbul ignore next */ (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }
              key={`dropchip-${chip.id}`}
            >
              <Chip
                id={chip.id}
                name={chip.name}
                link={chip.link}
                onRemove={onRemove}
                withTooltip={withTooltip}
              />
            </li>
          ))}
          <li onClick={onDropdownClose} className="close-item">
            <span
              data-testid="dropdown-close-button"
              className="icon icon-eh-show-less"
            />
          </li>
        </DropdownButton>
      </div>
    </div>
  );

  return (
    <div className="chips-container">
      <div ref={chipsRef} aria-hidden="true" className="chips">
        {items.map((item) => (
          <Chip
            id={item.id}
            key={`chips-container-${item.id}`}
            name={item.name}
            link={item.link}
            onRemove={onRemove}
          />
        ))}
      </div>
      <div data-testid="chips" className="chips">
        {(displayedChips as $TSFixMe)?.map((chip: $TSFixMe) => (
          <Chip
            id={chip.id}
            key={`chips-${chip.id}`}
            name={chip.name}
            link={chip.link}
            onRemove={onRemove}
            withTooltip={withTooltip}
          />
        ))}
        {dropdown}
      </div>
    </div>
  );
}
